<form [formGroup]="formGroup" (ngSubmit)="performSearch() ">
  <div class="valg-input-group__wrapper mb-0" [id]="id">
    <label valgLabel for="searchInput" class="sr-only">{{ 'sidenavigation.search.label' | translate }}</label>
    <div class="valg-input__wrapper">
      <div class="valg-input-search" #searchGroup>
        <input (input)="performSearch()" valgInput [valgAutofocus]="autoFocus" formControlName="query" [placeholder]="'sidenavigation.search.placeholder' | translate" #input id="searchInput">
        <mat-icon class="responsive-search-input" [svgIcon]="SvgIcon.Search"></mat-icon>
      </div>
    </div>
  </div>
</form>
